import React from "react";

export const StickyActions = ({ children, testId = "sticky-actions" }) => (
  <div className="sticky-actions sticky bottom-0 z-20 -mx-4 sm:-mx-5 px-4 sm:px-5 py-2.5 bg-background/90 backdrop-blur-md border-t border-border flex flex-wrap items-center justify-end gap-2" data-testid={testId}>
    {children}
  </div>
);
